import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import { batch } from 'react-redux'
import {
  BETSLIP_TABS,
  BetTypeGroup,
  BUTTON_SELECTION,
  MARKET_TABS,
  Mode,
  OddsFormat,
  SPORT_TABS,
  WagerMyBetMap,
  WinRiskType
} from '../common/Foundation';
import BetServices from '../services/BetServices';
import BetslipHelper from '../components/CompactView/LeftSideBarComponent/BetslipComponent/BetslipHelper';
import Constants from '../common/Constants';
import BetslipCommon from '../common/BetslipCommon';
import {openAlert, openModalMessage, opentConfirmAlert} from './AlertSlice';
import {changeButton, changeMarketId, changeMarketTab, changeSportId, changeSportTab} from './SidebarSelectedDataSlice';
import { fetchTeaserOddsSelection } from './TeaserBetslipSlice';
import {
  fetchParlayOddsSelectionInfo, getHRParlayLimitBet,
  removeAllParlayBets,
  updateParlayBetsState, updateParlayBetSuccessResState,
  updateParlayOddsRequestState
} from './ParlayBetslipSlice';
import { EVENT } from '../events/listEvents';
import CommonUtil from '../common/CommonUtil';
import AccountAction from '../actions/AccountAction'
import VSBetslipHelper from '../components/CompactView/LeftSideBarComponent/BetslipComponent/VSBetslipHelper';
import { triggerOddsPage, updateSportId } from './SidebarHandlerSlice';
import { updateIsSelectedHighlight } from './SportsSlice';
import {AccountsSlice} from './AccountsSlice';
import {getHRLimitBet, removeAllHRSingleBets, updateHRStakeInputsState, updatePlaceHRBetInfo, updateAllHRStake} from './HRBetslipSlice';
import moment from 'moment';
import {
  updateSingleBetsState as updateHRSingleBetsState,
} from './HRBetslipSlice';
import i18next from 'i18next';
import {GA4Common, GA_EVENT} from "../common/GA4Common";

const EMPTY_VALUE = ''
const EMPTY_ARRAY = []
const EMPTY_OBJECT = []
const defaultAttention = {
  message: Constants.ATTENTION_MESSAGE.ATTENTION,
  type: Constants.ATTENTION_TYPE.ERROR,
  display: 'center'
}

const initialState = {

  teaserBettingRules: EMPTY_VALUE,
  oddsSelection: [],
  selectedBetslipTab: BETSLIP_TABS.SINGLE,
  singleBets: [],

  totalStake: 0,
  potentialWinnings: 0,
  stakeInputs: {},
  invalidStake: false,
  pitchers: {},

  winRiskOptionPerBet: EMPTY_VALUE,
  stakePerBet: EMPTY_VALUE,

  isLoading: false,
  isError: false,
  hasErrorUpdatePitcher: false,
  acceptBetterOdds: BetslipHelper.loadDefaultAcceptBetterOdds(),
  isOpenConfirmationRemove: false,

  minMaxBets: {},
  currentOddsFormat: EMPTY_VALUE,

  startCountdown: false,
  resetCountdown: false,

  showAttention: false,

  acceptSelection: [],
  
  nonLoginCurrency: "",

  isInPlaceBetProcess: false,

  isUsedRememberSelections: false,
  winRiskOptions: {},
  isReuseSelection: false,
  attention:{
    PARLAY: defaultAttention,
    SINGLE: defaultAttention
  }  
}
export const BetslipSlice = createSlice({
    name: 'BetslipSlice',
    initialState: initialState,
    reducers: {
      updateOddsSelectionState: (state, {payload}) => {
        state.oddsSelection = payload
      },
      updateBetslipTabState: (state, {payload}) => {
        state.selectedBetslipTab = payload
      },
      updateSingleBetsState: (state, {payload}) => {
        //store data after call service get odds selection
        state.singleBets = payload
      },
      updateWinRiskOptionPerBetState: (state, {payload}) => {
        state.winRiskOptionPerBet = payload
      },
      updateTotalStakeState: (state, {payload}) => {
        state.totalStake = payload
      },
      updatePotentialWinningsState: (state, {payload}) => {
        state.potentialWinnings = payload
      },
      // keep stake input for calculating total stake and potential winnings
      updateStakeInputsState: (state, {payload}) => {
        state.stakeInputs = payload
        BetslipHelper.cacheObjectInLocalStorage(payload, 'stakeInputs')
      },
      updateInvalidStake: (state, {payload}) => {
        state.invalidStake = payload
      },
      updateAcceptBetterOddsState: (state, {payload}) => {
        state.acceptBetterOdds = payload
      },
      // keep pitcher selection for building payload for place bet service
      updatePitchersState: (state, {payload}) => {
        state.pitchers = payload
        BetslipHelper.cacheObjectInLocalStorage(payload, 'pitchers')
      },
      updateStakePerBetState: (state, {payload}) => {
        state.stakePerBet = payload
      },
      updateLoadingState: (state, {payload}) => {
        state.isLoading = payload
      },
      updateErrorState: (state, {payload}) => {
        state.isError = payload
      },
      updateConfirmationRemoveState: (state, {payload}) => {
        state.isOpenConfirmationRemove = payload
      },
      updateMinMaxBetState: (state, {payload}) => {
        state.minMaxBets = payload
      },
      updateCurrentOddsFormatState: (state, {payload}) => {
        state.currentOddsFormat = payload
      },
      initTeaserBettingRulesState: (state, {payload}) => {
        state.teaserBettingRules = payload
      },
      updateStartCountdownState: (state, {payload}) => {
        state.startCountdown = payload
      },
      updateResetCountdownState: (state, {payload}) => {
        state.resetCountdown = payload
      },
      updateShowAttentionState: (state, {payload}) => {
        state.showAttention = payload
      },
      updateWinRiskOptions: (state, { payload }) => {
        state.winRiskOptions = payload;
      },
      updateAttentionState: (state, {payload}) => {
        state.attention = {...state.attention, [state.selectedBetslipTab]: payload}
      },
      resetAttentionState: (state, {payload}) => {
        state.attention = {...state.attention, [state.selectedBetslipTab]: defaultAttention};
      },
      /**
       *  Update state after call servce
       * */

      updatePlaceSingleBetsSuccessState: (state, {payload}) => {
        state.oddsSelection = payload ? payload : []
        state.singleBets = []
        state.stakeInputs = {}
        state.pitchers = {}
       },
     
      updateAcceptSelectionState: (state, { payload }) => {
        state.acceptSelection = payload
      },

      setNonLoginCurrency: (state, { payload }) => {
        state.nonLoginCurrency = payload;
      },

      setIsInPlaceBetProcess: (state, { payload }) => {
        state.isInPlaceBetProcess = payload;
      },

      setIsUsedRememberSelections: (state, { payload }) => {
        state.isUsedRememberSelections = payload;
      },
      setIsReuseSelection: (state, {payload}) => {
        state.isReuseSelection = payload;
      }
    },
  });
  
export const {
  updateOddsSelectionState,
	updateBetslipTabState,
	updateSingleBetsState,
	updateWinRiskOptionPerBetState,
	updateTotalStakeState,
	updatePotentialWinningsState,
  updateStakeInputsState,
  updateInvalidStake,
	updateAcceptBetterOddsState,
	updatePitchersState,
	updateStakePerBetState,
	updateLoadingState,
  updateErrorState,
  updatePlaceSingleBetsSuccessState,
	updatePitcherParlaySuccess,
  updatePitcherParlayFailure,
  updateConfirmationRemoveState,
  updateMinMaxBetState,
  updateCurrentOddsFormatState,
  initTeaserBettingRulesState,
  updateStartCountdownState,
  updateResetCountdownState,
  updateShowAttentionState,
  updateAcceptSelectionState,
  setNonLoginCurrency,
  setIsInPlaceBetProcess,
  setIsUsedRememberSelections,
  updateWinRiskOptions,
  setIsReuseSelection,
  updateAttentionState,
  resetAttentionState
} = BetslipSlice.actions


export const fetchSingleOddsSelectionInfo = (params) => {
  return async (dispatch, getState) => {
    const {
      oddsSelection
    } = getState().BetslipSlice
    if (oddsSelection.length > 0) {
      const { oddsFormat } = getState().SportsSlice.options
      const isChangeOddsFormat = params && params.isChangeOddsFormat // change odds format from odds page
      const isAutoRefresh = params && params.isAutoRefresh // enable future auto refresh on betslip after specific time
      let payload = BetslipHelper.buildSingleOddsSelectionRequest(oddsSelection, oddsFormat)

      try {
        if (!isAutoRefresh) {
          dispatch(updateLoadingState(true))
        }
        const response = await BetServices.getAllOddsSelectionsInfo(payload).then(res => {
          return res.data;
        }).catch(err => {
          const errResponse = err.response;
          if (errResponse && errResponse.status === 403) {
            dispatch(handleMultiLoginError());
            return
          }         
        });
        batch(() => {
          dispatch(updateLoadingState(false))
          dispatch(updateStartCountdownState(true))
          dispatch(updateResetCountdownState(true))
          if (response.error) {
            dispatch(openAlert({
              message: 'errors:' + response.error
            }))
            // remove invalid section
            const validSelections = oddsSelection.filter((selection, index) => {
              return selection.oddsId !== payload.oddsSelections[0].oddsId
            })
            dispatch(updateOddsSelectionState(validSelections))
            return;
          }

          /**
           *  Max Bet Reference BASE
           *  CASE: User selected non-AM and wait for auto-refresh Odds
           * 
           * */
          if (!_.isNil(response) && !_.isNil(response[0]) && 
              Constants.BET_ERROR_CODE.INVALID_ODDS_FORMAT === response[0].status) {
            invalidOddsFormatHandle(dispatch);
            return;
          }

          dispatch(changeButton(BUTTON_SELECTION.BET_SLIP))

          // handle on all bets
          dispatch(updateSingleBetsState([
            ...BetslipHelper.transferInfoFromSelectionToSingleBets(
                oddsSelection, 
                BetslipHelper.isOddsChange(response)
                  ? BetslipHelper.addOldOdds(oddsSelection, response, oddsFormat)
                  : response,
                ['selectedAt', 'stake']
              )
          ]))

          // update new odds for stake inputs
          const oddsChangeBets = !isChangeOddsFormat
            ? response.filter(bet => {
                return bet.status === Constants.ODDS_STATUS.ODDS_CHANGE
              })
            : [];

          if (isChangeOddsFormat || oddsChangeBets.length > 0) { // change odds format from odds page
            const newStakeInputs = BetslipHelper.updateOddsForStakeInputs(
              getState().BetslipSlice.stakeInputs,
              oddsChangeBets.length > 0 
                ? oddsChangeBets 
                : response,
              oddsFormat
            )
            dispatch(updateStakeInputsState(newStakeInputs))
            dispatch(updatePlaceBetInfo())
          }
          const newMinMaxBets = BetslipHelper.updateMinMaxBet(getState().BetslipSlice.minMaxBets, response, oddsFormat, isChangeOddsFormat)
          dispatch(updateMinMaxBetState(newMinMaxBets))
          dispatch(updateCurrentOddsFormatState(oddsFormat))

          if (!params) {
            window.fireEvent(EVENT.SCROLL_TO_BOTTOM_AFTER_ADD_BET)
          }
        })

      } catch (error) {
        dispatch(updateLoadingState(false))
        dispatch(updateStartCountdownState(false))
      }
    } else {
      dispatch(updateSingleBetsState(EMPTY_ARRAY))
    }
  }
} 

export const removeSingleBetItem = (id) => {
  return async (dispatch, getState) => {
    const {oddsSelection, singleBets, pitchers, acceptSelection} = getState().BetslipSlice;
    const hrSingleBets = getState().HRBetslipSlice.singleBets;
    const {options} = getState().SportsSlice
    if ((oddsSelection.length + hrSingleBets.length + acceptSelection.length) === 1 || (singleBets.length + hrSingleBets.length) === 1) {
      batch(() => {
        dispatch(updateOddsSelectionState(EMPTY_ARRAY))
        dispatch(updateSingleBetsState(EMPTY_ARRAY))
        dispatch(updateStakeInputsState(EMPTY_OBJECT))
        dispatch(updateStakePerBetState(EMPTY_VALUE))
        dispatch(removeAllParlayBets())
        dispatch(updatePitchersState(EMPTY_OBJECT))
        dispatch(updateConfirmationRemoveState(false))
        dispatch(changeButton(BetslipHelper.getButtonSelection(options.isTopLeague, options.favourite)))
        dispatch(updateAcceptSelectionState(EMPTY_ARRAY))
        dispatch(updateWinRiskOptions(EMPTY_OBJECT));
      })
      
    } else {
      const { parlayOddsRequest, parlayBets } = getState().ParlayBetslipSlice
      const newPitchers = JSON.parse(JSON.stringify(pitchers))
      //update accept selection when remove
      const accept = acceptSelection.filter((selection, index) => {
        return selection.oddsId !== id
      })
      const selection = oddsSelection.filter((selection, index) => {
          return selection.oddsId !== id
        })
        const bets = singleBets.filter((bet, index) => {
          return bet.oddsId !== id
        })
        batch(() => {
          dispatch(updateOddsSelectionState(selection));
          dispatch(updateSingleBetsState(bets));
          dispatch(updateAcceptSelectionState(accept));
          const stakeInputs = Object.assign({}, getState().BetslipSlice.stakeInputs);
          const minMaxBets = Object.assign({}, getState().BetslipSlice.minMaxBets);
          const winRiskOptions = Object.assign({}, getState().BetslipSlice.winRiskOptions);
          if (stakeInputs[id]) {
            delete stakeInputs[id];
            delete minMaxBets[id];
            delete winRiskOptions[id];
            dispatch(updateStakeInputsState(stakeInputs));
            dispatch(updateMinMaxBetState(minMaxBets));
            dispatch(updateWinRiskOptions(winRiskOptions));
            dispatch(updatePlaceBetInfo());
          }
        })
        
        if (pitchers[id]) {
          delete newPitchers[id]
        }
       
        if (Object.keys(parlayOddsRequest).length > 0) {
          if (parlayOddsRequest.parlayOddsRequest.parlayOddsSelections.length === 1) {
            batch(() => {
              dispatch(updateParlayOddsRequestState(EMPTY_OBJECT))
              dispatch(updateParlayBetsState(EMPTY_ARRAY))
            })
            
          } else {
            let payload = JSON.parse(JSON.stringify(parlayOddsRequest)) 
            const { parlayOddsSelections } = payload.parlayOddsRequest  
            const legId = BetslipHelper.getLegIdByOddsId(oddsSelection, parlayOddsRequest, id)
            const leg =  parlayBets.legs && parlayBets.legs.filter(leg => {
              return leg.legId === legId
            })
            if (leg.length > 0) {
              const selectionId = leg[0].selectionId
              if (pitchers[selectionId]) {
                delete pitchers[selectionId]
              }
            }
            const parlayOdds = parlayOddsSelections.filter((odds, index) => {
              return odds.legId !== legId
            })
            payload.parlayOddsRequest.parlayOddsSelections = parlayOdds
            const response =  await BetServices.parlayRemoveSelection(payload, legId).then(res => {
              return res.data;
            }).catch(e => {
        
            });
            batch(() => {
              dispatch(updateParlayOddsRequestState(payload))
              dispatch(updateParlayBetsState(response))
            })
           
          }
        }
        batch(() => {
          dispatch(updateStakePerBetState(EMPTY_VALUE))
          dispatch(updatePitchersState(newPitchers))
        })
    }    
  }    
}

export const removeAllSingleBets = () => {
  return (dispatch, getState) => {
    const { options } = getState().SportsSlice;
    batch(() => {
      dispatch(updateOddsSelectionState(EMPTY_ARRAY))
      dispatch(updateAcceptSelectionState(EMPTY_ARRAY))
      dispatch(updateSingleBetsState(EMPTY_ARRAY))
      dispatch(updateStakeInputsState(EMPTY_OBJECT))
      dispatch(updateStakePerBetState(EMPTY_VALUE))
      dispatch(removeAllParlayBets())
      dispatch(updatePitchersState(EMPTY_OBJECT))
      dispatch(updateConfirmationRemoveState(false))
      dispatch(updateStartCountdownState(false))
      dispatch(changeButton(BetslipHelper.getButtonSelection(options.isTopLeague, options.favourite)))
      dispatch(removeAllHRSingleBets());
    })
  }
}

export const changeStakeInputs = (inputs) => {
  return (dispatch, getState) => {
    let stakeInputs = JSON.parse(JSON.stringify(getState().BetslipSlice.stakeInputs))
    if (stakeInputs[inputs.oddsId]) {
      Object.assign(stakeInputs[inputs.oddsId], inputs)
    } else {
      stakeInputs[inputs.oddsId] = inputs
    }
    dispatch(updateStakeInputsState(stakeInputs))
  }
}

export const changeMinMaxBets = (inputs) => {
  return (dispatch, getState) => {
    let minMaxBets = JSON.parse(JSON.stringify(getState().BetslipSlice.minMaxBets))
    if (minMaxBets[inputs.oddsId]) {
      Object.assign(minMaxBets[inputs.oddsId], inputs)
    } else {
      minMaxBets[inputs.oddsId] = inputs
    }
    dispatch(updateMinMaxBetState(minMaxBets))
  }
}

export const updateAllStake = (stake, winRiskOption) => {
  return (dispatch, getState) => {
    const { oddsFormat } = getState().SportsSlice.options
    let stakeInputs = JSON.parse(JSON.stringify(getState().BetslipSlice.stakeInputs))
    Object.keys(stakeInputs).forEach(key => {
      let inputs = {}
      let winRiskStake = winRiskOption;
      if (!winRiskStake) {
        winRiskStake = BetslipHelper.getWinRiskOptionByOdds(stakeInputs[key].odds)
      }
      if (winRiskStake === WinRiskType.RISK) {
        inputs.winRiskOption = winRiskStake
        inputs.riskVal = stake ? BetslipCommon.convertStakeToNumber(stake) : '';
        inputs.winVal = stake ? BetslipCommon.calculateToWin(inputs.riskVal, stakeInputs[key].odds, oddsFormat, winRiskStake, stakeInputs[key].betType) : ''
        inputs.baseVal = BetslipHelper.calculateBaseVal(stakeInputs[key].baseVal, stakeInputs[key].odds, inputs.riskVal, inputs.winVal);
      } else if (winRiskStake === WinRiskType.WIN) {
        inputs.winRiskOption = winRiskStake
        inputs.winVal = stake ? BetslipCommon.convertStakeToNumber(stake) : '';
        inputs.riskVal = stake ? BetslipCommon.calculateToRisk(inputs.winVal, stakeInputs[key].odds, oddsFormat, winRiskStake) : ''
        inputs.baseVal = BetslipHelper.calculateBaseVal(stakeInputs[key].baseVal, stakeInputs[key].odds, inputs.riskVal, inputs.winVal);
      } else if (winRiskStake === WinRiskType.BASE) {
        inputs.winRiskOption = winRiskStake
        inputs.baseVal = stake ? BetslipCommon.convertStakeToNumber(stake) : '';
        inputs.winVal = stake ? BetslipCommon.calculateToWin(inputs.baseVal, stakeInputs[key].odds, oddsFormat, winRiskStake, stakeInputs[key].betType) : '';
        inputs.riskVal = stake ? BetslipCommon.calculateToRisk(inputs.baseVal, stakeInputs[key].odds, oddsFormat, winRiskStake) : '';
      }
      Object.assign(stakeInputs[key], inputs)
    })
    batch(() => {
      dispatch(updateStakePerBetState(stake))
      dispatch(updateStakeInputsState(stakeInputs))
    })
   
  }
}

export const updateAllMinMaxBet = (event, winRiskOption) => {
  return (dispatch, getState) => {
    let minMaxBets= JSON.parse(JSON.stringify(getState().BetslipSlice.minMaxBets))
    Object.keys(minMaxBets).forEach(key => {
      minMaxBets[key].winRiskOption = winRiskOption ? winRiskOption : BetslipHelper.getWinRiskOptionByOdds(minMaxBets[key].odds)
    })
    dispatch(updateMinMaxBetState(minMaxBets))
  }
}

export const updateStakeAndWinRiskOption = (stake, winRiskOption) => {
  return dispatch => {
    batch(() => {
      dispatch(updateStakePerBetState(stake))
      dispatch(updateWinRiskOptionPerBetState(winRiskOption ? winRiskOption : EMPTY_VALUE))
    })
  }
}

export const resetStakeAndWinRiskOption = () => {
  return dispatch => {
    batch(() => {
      dispatch(updateStakePerBetState(EMPTY_VALUE))
      dispatch(updateWinRiskOptionPerBetState(EMPTY_VALUE))
    })
  }
}

export const updatePlaceBetInfo = () => {
  return (dispatch, getState) => {
    const { stakeInputs } = getState().BetslipSlice
    batch(() => {
      dispatch(updateTotalStakeState(BetslipHelper.calculateTotalStake(stakeInputs)))
      dispatch(updatePotentialWinningsState(BetslipHelper.calculatePotentialWinnings(stakeInputs)))
    })
  
  }
}

export const executePlaceSingleBets = () => {
  return async (dispatch, getState) => {
    const { 
      singleBets,
      stakeInputs,
      acceptBetterOdds,
      pitchers,
    } = getState().BetslipSlice

    const {
      oddsFormat 
    } = getState().SportsSlice.options

    const {
      betCredit:currentBalance
    }=getState().AccountsSlice.user;
    let GAErrorMessage = "";

    const payload = BetslipHelper.buildPayloadPlaceSingleBets(singleBets, stakeInputs, pitchers, oddsFormat, acceptBetterOdds)
    if(_.isEmpty(payload.selections)) {
      return;
    }
    try {
      dispatch(updateLoadingState(true))
      dispatch(setIsInPlaceBetProcess(true));
      const uniqueRequestId = BetslipCommon.generateUUID();
      const res =  await BetServices.postPlaceBetAPI(payload, uniqueRequestId);
      dispatch(updateLoadingState(false))
      dispatch(setIsInPlaceBetProcess(false));
      if (res) {
        const { errorCode, response, errorMessage } = res.data
        if (errorCode) {
          let tmp = {
            message: 'errors:'+ errorCode,
          }
          if (errorCode === Constants.BET_ERROR_CODE.RESPONSIBLE_LIMIT_EXCEEDED_RISK_WITH_MULTIPLE_BET
            || errorCode === Constants.BET_ERROR_CODE.RESPONSIBLE_LIMIT_EXCEEDED_LOSS_WITH_MULTIPLE_BET) {
            if (response.length > 0) {
              tmp.params = [response.data.errorMessage]
            } else if (errorMessage) {
              tmp.params = [errorMessage]
            }
          }
          if (errorCode === Constants.BET_ERROR_CODE.BETTING_BUDGET_EXCEEDED) {
              tmp.params = [errorMessage]
          }
          if(errorCode ===  Constants.BET_ERROR_CODE.INVALID_BET_ACCEPTANCE_TYPE) {
            dispatch(openAlert('errors:'+ errorCode))
          }
          dispatch(openAlert(tmp))
          GAErrorMessage = errorCode;
          return
        } 
        
        /**
         *  Max Bet Reference BASE
         *  CASE: User selected non-AM => Change Setting => User place bet
         * 
         * */
        else if (!_.isNil(response) && !_.isNil(response[0]) &&
            Constants.BET_ERROR_CODE.INVALID_ODDS_FORMAT === response[0].errorCode) {
          invalidOddsFormatHandle(dispatch);
          GA4Common.sendEventGA(GA_EVENT.BET_SLIP, {currentBalance, errorCode: Constants.BET_ERROR_CODE.INVALID_ODDS_FORMAT});
          return;
        } else {
          const singleBets = JSON.parse(JSON.stringify(getState().BetslipSlice.singleBets))
          const oddsSelection = JSON.parse(JSON.stringify(getState().BetslipSlice.oddsSelection))
          const stakeInputs = JSON.parse(JSON.stringify(getState().BetslipSlice.stakeInputs))
          const minMaxBets = JSON.parse(JSON.stringify(getState().BetslipSlice.minMaxBets))
          const acceptSelection = JSON.parse(JSON.stringify(getState().BetslipSlice.acceptSelection))
          const winRiskOptionReuse = JSON.parse(JSON.stringify({}));
          let isLineChanged = false;
          let successBet = 0
          response.forEach((res, index) => {
            const betIndex = singleBets.findIndex(item => {
              return item.oddsId === res.oddsId;
            })
            if (betIndex > -1) {
              winRiskOptionReuse[res.oddsId] = {
                winRiskOption: stakeInputs[res.oddsId].winRiskOption
              };
              if (res.status === Constants.BET_STATUS.ACCEPTED) {
                 const selectionIdx = oddsSelection.findIndex(sel => {
                  return sel.oddsId === res.oddsId
                })

                Object.assign(singleBets[betIndex], {
                  wagerId: res.wagerId,
                  risk: res.psBetVO.risk,
                  win: res.psBetVO.win,
                  status: res.psBetVO.betStatus,
                  stake: BetslipHelper.getStake(stakeInputs, singleBets[betIndex].oddsId),
                  plRes: (oddsSelection[selectionIdx] || {}).parlayRestriction
                })

                // update odds selection
                if (selectionIdx > -1) {
                  oddsSelection.splice(selectionIdx, 1);
                }
               
                // add accept selection
                acceptSelection.push(res)
                // update stake inputs
                delete stakeInputs[res.oddsId]
                delete minMaxBets[res.oddsId]
                successBet += 1
              } else if (res.status === Constants.BET_STATUS.PENDING_ACCEPTANCE) {
                Object.assign(singleBets[betIndex], {
                  status: Constants.BET_STATUS.PENDING_ACCEPTANCE,
                  wagerId: res.wagerId,
                })
                delete stakeInputs[res.oddsId]
                delete minMaxBets[res.oddsId]
                // update odds selection
                const selectionIdx = oddsSelection.findIndex(sel => {
                  return sel.oddsId === res.oddsId
                })
                if (selectionIdx > -1) {
                  oddsSelection.splice(selectionIdx, 1);
                }
                successBet += 1
                // add accept selection
                acceptSelection.push(res)
              } else if (res.status === Constants.BET_STATUS.PROCESSED_WITH_ERROR) {
                let updateData = {}
                if (res.jsonString) {
                  const json = JSON.parse(res.jsonString);
                  const uniqueRequestId = res.uniqueRequestId;
                  const jsonDetail = json.bets.filter(bet => {
                      return bet.uniqueRequestId === uniqueRequestId;
                  })
                
                  if (res.errorCode === Constants.BET_ERROR_CODE.LINE_CHANGED) {
                    let isGenerateNewSelectionId = true
                    updateData.lineId = jsonDetail[0].lineId;
                    updateData.maxRiskStake = jsonDetail[0].maxRiskStake
                    updateData.maxWinStake = jsonDetail[0].maxWinStake
                    updateData.minRiskStake = jsonDetail[0].minRiskStake
                    updateData.minWinStake = jsonDetail[0].minWinStake
                    if (singleBets[betIndex].altLineId) {
                      updateData.altLineId = jsonDetail[0].altLineId;
                    }
                    if (Number(singleBets[betIndex].odds) !== Number(jsonDetail[0].price)) {
                      updateData.status = Constants.ODDS_STATUS.ODDS_CHANGE
                      updateData.odds = jsonDetail[0].price.toString()
                      updateData.oldOdds = singleBets[betIndex].odds

                      const currentInput = stakeInputs[singleBets[betIndex].oddsId]

                      currentInput.odds = updateData.odds
                      let winRiskOption = currentInput.winRiskOption
                      if (oddsFormat !== OddsFormat.AM && oddsFormat !== OddsFormat.EU) {
                        winRiskOption = BetslipHelper.getWinRiskOptionByOdds(currentInput.odds)
                      }
                      if (winRiskOption === WinRiskType.RISK) {
                        const riskVal = BetslipCommon.convertStakeToNumber(currentInput.riskVal)
                        currentInput.winVal = BetslipCommon.calculateToWin(riskVal, updateData.odds, oddsFormat, WinRiskType.RISK, currentInput.betType)
                      } else if (winRiskOption === WinRiskType.WIN) {
                        const winVal = BetslipCommon.convertStakeToNumber(currentInput.winVal)
                        currentInput.riskVal = BetslipCommon.calculateToRisk(winVal, updateData.odds, oddsFormat, WinRiskType.WIN)
                      }
                      currentInput.winRiskOption = winRiskOption
                      isGenerateNewSelectionId = false
                      
                    }
                    if (isGenerateNewSelectionId) {
                      // generate new selection id for submit again
                      const newSelectionId = BetslipHelper.generateNewSelectionId(singleBets[betIndex].selectionId, updateData);
                      updateData.selectionId = newSelectionId;
  
                      const selectionIndex = oddsSelection.findIndex(item => {
                        return item.oddsId === res.oddsId;
                      })
                      if (selectionIndex > -1) {
                        const newSelectionId = oddsSelection[selectionIndex].selectionId.split('|')
                        newSelectionId[0] = updateData.lineId
                        oddsSelection[selectionIndex].selectionId = newSelectionId.join('|')
                      }
                    }
                    isLineChanged = true;

                  } else if (res.errorCode === Constants.BET_ERROR_CODE.EVENT_OFFLINE) {
                    updateData.errorCode = jsonDetail[0].errorCode;
                    updateData.status = Constants.UNAVAILABLE
                  } else if (res.errorCode === Constants.BET_ERROR_CODE.MAX_BET_EXCEEDED) {
                    // update win/risk value
                    const currentInput = stakeInputs[res.oddsId]
                    if (currentInput.winRiskOption === WinRiskType.RISK) {
                      currentInput.riskVal = BetslipCommon.convertStakeToNumber(res.errorData)
                      currentInput.winVal = BetslipCommon.calculateToWin(currentInput.riskVal, updateData.odds, oddsFormat, WinRiskType.RISK, currentInput.betType)
                    } else if (currentInput.winRiskOption === WinRiskType.WIN) {
                      currentInput.winVal = BetslipCommon.convertStakeToNumber(res.errorData)
                      currentInput.riskVal = BetslipCommon.calculateToRisk(currentInput.winVal, updateData.odds, oddsFormat, WinRiskType.WIN)
                    }
                  } else if (res.errorCode) {
                    updateData.status = Constants.EMPTY_VALUE
                    updateData.errorCode = res.errorCode;
                    updateData.errorData = res.errorData;
                  }
                  Object.assign(singleBets[betIndex], updateData)
                } else if (res.errorCode) {
                  updateData.status = EMPTY_VALUE
                  updateData.errorCode = res.errorCode;
                  updateData.errorData = res.errorData;
                  Object.assign(singleBets[betIndex], updateData)
                }
              } else if (res.errorCode) {
                let updateData = {}
                updateData.status = EMPTY_VALUE
                updateData.errorCode = res.errorCode;
                updateData.errorData = res.errorData;
                Object.assign(singleBets[betIndex], updateData)
              }
            }
          })
          GA4Common.sendEventGA(GA_EVENT.BET_SLIP, {
            currentBalance,
            errorCode: (singleBets || []).map(item => {
              const responseWithBetsItem = (response || []).find(res => res.oddsId === item.oddsId);
              return _.get(responseWithBetsItem, "errorCode") || _.get(item, "errorCode") || "";
            }).join()
          });
          batch(() => {
            dispatch(updateOddsSelectionState(oddsSelection));
            dispatch(updateAcceptSelectionState(acceptSelection));
            dispatch(updateStakeInputsState(stakeInputs));
            dispatch(updatePlaceBetInfo());
            dispatch(updateSingleBetsState(singleBets));
            dispatch(updateWinRiskOptions(winRiskOptionReuse));
            if (successBet === response.length) {
              dispatch(updateStakePerBetState(EMPTY_VALUE))
              dispatch(updateParlayBetsState(EMPTY_ARRAY));
            } else if(isLineChanged) {
              dispatch(fetchSingleOddsSelectionInfo());
            }
            if (successBet > 0) {
              reloadBalanceAndPendingBets()
              dispatch(setIsReuseSelection(false));
            }
          })
         
        }
      } else {
        dispatch(openAlert({
          message: 'errors:'+ Constants.BET_ERROR_CODE.INTERNAL_ERROR
        }))
        GAErrorMessage = Constants.BET_ERROR_CODE.INTERNAL_ERROR;
      }
    } catch (error) {
      GAErrorMessage = Constants.BET_ERROR_CODE.RESUBMIT_REQUEST
      const singleBets = JSON.parse(JSON.stringify(getState().BetslipSlice.singleBets));
      const updateData = {
        status: EMPTY_VALUE,
        errorCode : Constants.BET_ERROR_CODE.RESUBMIT_REQUEST,
        errorData: EMPTY_VALUE
      };
      singleBets.map((item) => {
        Object.assign(item, updateData);
      });
      dispatch(updateSingleBetsState(singleBets));
      dispatch(updateLoadingState(false));
      dispatch(setIsInPlaceBetProcess(false));
    } finally {
      GAErrorMessage && GA4Common.sendEventGA(GA_EVENT.BET_SLIP, {errorCode: GAErrorMessage, currentBalance});
    }
  }
}

export const changePitchers = (id, name, isChecked) => {
  return (dispatch, getState) => {
    let pitchers = Object.assign({}, getState().BetslipSlice.pitchers)
    let mustStart = Object.assign({}, pitchers[id]) 
    mustStart[name] = isChecked
    pitchers[id] = mustStart
    dispatch(updatePitchersState(pitchers))
  }
}
export const initPitchers = (input) => {
  return (dispatch, getState) => {
    let pitchers = Object.assign({}, getState().BetslipSlice.pitchers)
    pitchers[input.id] = {
      pitcher1MustStart: input.pitcher1MustStart,
      pitcher2MustStart: input.pitcher2MustStart
    }
    dispatch(updatePitchersState(pitchers))
  }
}

export const addOddsSelection = (selection)  => {
  return async (dispatch, getState) => {
    let oddsSelection = JSON.parse(JSON.stringify(getState().BetslipSlice.oddsSelection))
      if (oddsSelection.length === 0) {
        oddsSelection.push(selection)
      } else {
          const existingIndex = BetslipHelper.isSelectedOdd(selection, oddsSelection);
          if (existingIndex === -1) {
            if (oddsSelection.length >= 10) {
              dispatch(openAlert({
                message: 'Maximum is 10 selections.'
              }))
              return
            }
            oddsSelection.push(selection);
          } else {
            if(oddsSelection[existingIndex].oddsId != selection.oddsId) {
              oddsSelection.push(selection);
            }
            
            const stakeInputs = Object.assign({}, getState().BetslipSlice.stakeInputs)
            const minMaxBets = Object.assign({}, getState().BetslipSlice.minMaxBets)
            const oddIds = oddsSelection[existingIndex].oddsId
            if (stakeInputs[oddIds]) {
              delete stakeInputs[oddIds]
              delete minMaxBets[oddIds]
              batch(() => {
                dispatch(updateStakeInputsState(stakeInputs))
                dispatch(updateMinMaxBetState(minMaxBets))
                dispatch(updatePlaceBetInfo())
              })
              
            }
            oddsSelection.splice(existingIndex, 1);
          }
      }
      if (getState().BetslipSlice.selectedBetslipTab === BETSLIP_TABS.SINGLE) {
        if (oddsSelection.length > 0){
          const { oddsFormat }  = getState().SportsSlice.options
          let payload = BetslipHelper.buildSingleOddsSelectionRequest(oddsSelection, oddsFormat)
          dispatch(updateLoadingState(true))
          try{
            const response =  await BetServices.getAllOddsSelectionsInfo(payload).then(res => {
              return res.data;
            }).catch(err => {
              const errResponse = err.response;
              if (errResponse && errResponse.status === 403) {
                dispatch(handleMultiLoginError());
                return
              }              
            });
            Promise.resolve(batch(() => {
              dispatch(updateLoadingState(false))
              dispatch(updateStartCountdownState(true))
              dispatch(updateResetCountdownState(true))
              if (response.error) {
                dispatch(openAlert({
                  message: 'errors:'+ response.error
                }))
                // remove invalid section
                const validSelections = oddsSelection.filter((selection, index) => {
                  return selection.oddsId !== payload.oddsSelections[0].oddsId 
                })
                dispatch(updateOddsSelectionState(validSelections))
                return;
              } 
              let newOddsSelection = response[0].status;
              /**
               *  Max Bet Reference BASE
               *  CASE: In-session => Change setting => User selected non-AM
               * 
               * */
              if (Constants.BET_ERROR_CODE.INVALID_ODDS_FORMAT === newOddsSelection) {
                invalidOddsFormatHandle(dispatch);
                return;
              } else if (newOddsSelection !== 'UNAVAILABLE') {
                dispatch(updateOddsSelectionState(oddsSelection))
                dispatch(changeButton(BUTTON_SELECTION.BET_SLIP))
                
                // handle on all bets
                dispatch(updateSingleBetsState([
                  ...BetslipHelper.transferInfoFromSelectionToSingleBets(
                      oddsSelection,
                      BetslipHelper.isOddsChange(response)
                        ? BetslipHelper.addOldOdds(oddsSelection, response, oddsFormat) 
                        : response,
                        ['selectedAt', 'stake']
                    )
                ]))
                
                // update new odds for stake inputs
                const oddsChangeBets = response.filter(bet => {
                  return bet.status ===  Constants.ODDS_STATUS.ODDS_CHANGE
                })

                if(oddsChangeBets.length > 0){
                  const newStakeInputs = BetslipHelper.updateOddsForStakeInputs(
                    getState().BetslipSlice.stakeInputs, 
                    oddsChangeBets.length > 0 
                      ? oddsChangeBets 
                      : response,
                    oddsFormat
                  )
                  dispatch(updateStakeInputsState(newStakeInputs))
                  dispatch(updatePlaceBetInfo())
                }
                const newMinMaxBets = BetslipHelper.updateMinMaxBet(getState().BetslipSlice.minMaxBets, response, oddsFormat, false)
                dispatch(updateMinMaxBetState(newMinMaxBets))
                dispatch(updateCurrentOddsFormatState(oddsFormat))
              } else {
                dispatch(openModalMessage({
                  message: 'errors:Current selection is unavailable for betting.',
                  title: 'Selection unavailable',
                }))
              }
            })).then(() => {
              window.fireEvent(EVENT.SCROLL_TO_BOTTOM_AFTER_ADD_BET)
            })
            
          }catch (err){
            dispatch(updateLoadingState(false))
            dispatch(updateStartCountdownState(false))
          }
        } else {
          batch(() => {
            dispatch(updateOddsSelectionState(oddsSelection))
            dispatch(updateSingleBetsState(EMPTY_ARRAY))
          })

        }
      } else if (getState().BetslipSlice.selectedBetslipTab === BETSLIP_TABS.PARLAY) {
        batch(() => {
          dispatch(updateOddsSelectionState(oddsSelection))
          dispatch(fetchParlayOddsSelectionInfo())
        })

      }
    const hrSingleBets = getState().HRBetslipSlice.singleBets;
    const updatedHrSingleBets = hrSingleBets.filter(bet => bet.status !== Constants.HR_BET_STATUS.ACCEPTED);
    dispatch(updateHRSingleBetsState(updatedHrSingleBets));
  }
}

export const changeBetslipTab = (tabId, t) => {
  return (dispatch, getState) => {
    const currentTab = getState().BetslipSlice.selectedBetslipTab
    const {
      teaserSelections,
    } = getState().TeaserBetslipSlice
    const {
      oddsSelection,
      isOpenConfirmationRemove
    } = getState().BetslipSlice
    batch(() => {
      if (currentTab !== tabId) {
        dispatch(updateBetslipTabState(tabId))
        const selectedMarketTab = getState().SidebarSelectedDataSlice.selectedMarketTab
        const {sports, markets} = getState().SidebarHandlerSlice
        const sportId = getState().SportsSlice.options.sportId
        let isEsport = false
        let sportTab
        if (sports.length > 0) {
          isEsport = sportId === Constants.ESPORT_ID
          sportTab = isEsport ? SPORT_TABS.ESPORTS : SPORT_TABS.SPORTS
        }

        dispatch(updateSportId(isEsport ? Constants.ESPORT_ALL_GAMES_CODE : sportId, isEsport ? SPORT_TABS.ESPORTS : SPORT_TABS.SPORTS, selectedMarketTab))
        
        if (tabId === BETSLIP_TABS.SINGLE) {
          if (oddsSelection.length > 0) {
            dispatch(fetchSingleOddsSelectionInfo())
          }
          const betTypeGroupId = _.head(
              markets
                  .map(item => item.marketId.split(Constants.KEYBOARD.PIPE)[0])
                  .filter(item => ![BetTypeGroup.MIX_PARLAY, BetTypeGroup.TEASERS].includes(Number(item)))
          );
          dispatch(handleTriggerOddsPage(sportId, sportTab, selectedMarketTab, betTypeGroupId || BetTypeGroup.HDP_OU, getState().SportsSlice.options.mode))
        } else if (tabId === BETSLIP_TABS.PARLAY) {
          if (oddsSelection.length > 0) {
            dispatch(fetchParlayOddsSelectionInfo())
          }
          dispatch(handleTriggerOddsPage(sportId, sportTab, selectedMarketTab, BetTypeGroup.MIX_PARLAY, getState().SportsSlice.options.mode))
        }
      }

      if (tabId === BETSLIP_TABS.TEASERS) {
        if (teaserSelections.length > 0) {
          dispatch(fetchTeaserOddsSelection())
        }
      }
      if (isOpenConfirmationRemove) {
        dispatch(updateConfirmationRemoveState(false))
      }
    })
    const {
      singleBets,
      hrBetslipItemList,
    } = getState().HRBetslipSlice;
    if (tabId === BETSLIP_TABS.SINGLE) {
      const updatedHRBetslipItemList = hrBetslipItemList.reduce((hrBetSlip, hrItem) => {
        if(hrItem.status !== Constants.HR_BET_STATUS.ACCEPTED) {
          if(hrItem.errorCode === Constants.BET_ERROR_CODE.CORRELATED) {
            hrItem = {...hrItem, errorCode: false}
          }
          hrBetSlip.push(hrItem);
        }
        return hrBetSlip;
      }, []);
      const parlayBetsSucessRes = getState().ParlayBetslipSlice.parlayBetsSucessRes;
      dispatch(updateHRSingleBetsState(updatedHRBetslipItemList));
      parlayBetsSucessRes && Object.keys(parlayBetsSucessRes).length > 0 && dispatch(updateHRSingleBetsState(EMPTY_ARRAY));
      dispatch(getHRLimitBet());
      dispatch(updateAllHRStake());
    } else if (tabId === BETSLIP_TABS.PARLAY) {
      const { currency } = getState().AccountsSlice.user;
      const parlayBets = getState().ParlayBetslipSlice.parlayBets;
      const {legs, minRiskStake, maxRiskStake, roundRobinOptions} = parlayBets;

      const betSlipItemList = singleBets
          .filter(item => item.status !== Constants.HR_BET_STATUS.ACCEPTED)
          .map(item => item.betSlipEmit)
          .reduce((previousResult, item) => {
            const {
              startTime,
              betType,
              runnerName,
              raceNumber,
              runnerNumber,
              odds,
              userOdds,
              raceName,
              meetingId
            } = item.legs[0]
            const dateTime = moment(startTime)
            const date = dateTime.format('YYYY-MM-DD')
            const oddsId = BetslipHelper.buildHROddsId(item.legs[0])
            const correlatedIndex = previousResult.findIndex(bet => bet.raceNumber === raceNumber && bet.meetingId === meetingId)
            return [...previousResult, {
              betExtraInfo: `${date}\u00A0\u00A0${_.capitalize(t(`${betType}_rb`))}`,
              selectionInfo: `${runnerNumber} ${runnerName}`,
              errorCode: correlatedIndex >= 0 && Constants.BET_ERROR_CODE.CORRELATED,
              oddsDisplay: userOdds,
              odds,
              oddsId,
              raceName,
              raceNumber,
              runnerNumber,
              betType,
              meetingId,
              legId: oddsId,
              currencyCode: currency,
              betSlipEmit: { ...item, type: 'MULTI', odds, userOdds },
              sportId: Constants.HORSE_RACING_ID,
              isHRParlay: true
            }]
          }, []);
      const updatedLegs = legs && legs.every(bet => bet.sportId !== Constants.HORSE_RACING_ID) ? [...legs, ...betSlipItemList] : betSlipItemList;
      const dummyRRO = [{
        'roundRobinOption': "Parlay",
        'odds': 4.655,
        'unroundedDecimalOdds': 4.6559459,
        'totalLegs': betSlipItemList.length,
        'rroLegs': betSlipItemList.length,
        'possibleWagers': 1,
      }]
      const parlayState = {
        ...parlayBets,
        minRiskStake: minRiskStake || 0,
        maxRiskStake: maxRiskStake || 0,
        minWinStake: minRiskStake || 0,
        maxWinStake: maxRiskStake || 0,
        legs: updatedLegs,
        roundRobinOptions: roundRobinOptions || dummyRRO,
        isHRParlay: betSlipItemList.length > 0,
        parlayStake: 0,
        invalidStake: false,
      };

      const hasError = parlayState.legs && parlayState.legs.some(bet => bet.errorCode);
      const parlayBetsSucessRes = getState().ParlayBetslipSlice.parlayBetsSucessRes;
      batch(() => {
        if (Object.keys(parlayBetsSucessRes).length > 0 && singleBets.length > 0) {
          dispatch(updateParlayBetSuccessResState(EMPTY_OBJECT));
        }
        dispatch(updateParlayBetsState(parlayState));
        !hasError && parlayState.legs.length > 0 && setTimeout(() => {
          dispatch(getHRParlayLimitBet())
        }, 100)
      });
    }
    window.fireEvent(EVENT.SCROLL_TO_BOTTOM_AFTER_ADD_BET);
  }
}

const handleMultiLoginError = () => {
  return dispatch => {
    AccountAction.clearCookie();
    dispatch(AccountsSlice.actions.resetUser());
    dispatch(openAlert(
      {
        message: "errors:MULTIPLE_LOGIN"
      }
    ))
  }
  
}

const handleTriggerOddsPage = (sportId, sportTab, marketTab, betTypeGroup, mode) => {
  return dispatch => {
    batch(() => {
      dispatch(changeSportId(sportId))
      dispatch(changeSportTab(sportTab))
      dispatch(changeMarketTab(marketTab))
      dispatch(changeMarketId([betTypeGroup, 0].join('|')))
      dispatch(updateIsSelectedHighlight(false))
      if(mode !== Mode.SEARCH) {
      dispatch(triggerOddsPage())
      }
    })    
  }     
}

export const updateMaxBetByOddsId = (stake, oddsId) => {
  return (dispatch, getState) => {
    const { minMaxBets } = getState().BetslipSlice
    const winRiskOption = minMaxBets[oddsId].winRiskOption
    let stakeInputs = JSON.parse(JSON.stringify(getState().BetslipSlice.stakeInputs))
    const { oddsFormat }  = getState().SportsSlice.options

    switch (winRiskOption) {
      case WinRiskType.RISK:
        stakeInputs[oddsId].riskVal = BetslipCommon.convertStakeToNumber(stake);
        stakeInputs[oddsId].winVal = BetslipCommon.calculateToWin(stakeInputs[oddsId].riskVal, stakeInputs[oddsId].odds, oddsFormat, winRiskOption, stakeInputs[oddsId].betType);
        break;
      case WinRiskType.WIN:
        stakeInputs[oddsId].winVal = BetslipCommon.convertStakeToNumber(stake);
        stakeInputs[oddsId].riskVal = BetslipCommon.calculateToRisk(stakeInputs[oddsId].winVal, stakeInputs[oddsId].odds, oddsFormat, winRiskOption);
        break;
      default: //option = BASE
        if (stakeInputs[oddsId].odds > 0) {
          stakeInputs[oddsId].riskVal = BetslipCommon.convertStakeToNumber(stake);
          stakeInputs[oddsId].winVal = BetslipCommon.calculateToWin(stakeInputs[oddsId].riskVal, stakeInputs[oddsId].odds, oddsFormat, winRiskOption, stakeInputs[oddsId].betType);
        } else {
          stakeInputs[oddsId].winVal = BetslipCommon.convertStakeToNumber(stake);
          stakeInputs[oddsId].riskVal = BetslipCommon.calculateToRisk(stakeInputs[oddsId].winVal, stakeInputs[oddsId].odds, oddsFormat, winRiskOption);
        }
    }
    stakeInputs[oddsId].baseVal = BetslipHelper.calculateBaseVal(stakeInputs[oddsId].baseVal,
      stakeInputs[oddsId].odds,
      stakeInputs[oddsId].riskVal,
      stakeInputs[oddsId].winVal);
    stakeInputs[oddsId].winRiskOption = winRiskOption
    batch(() => {
      dispatch(updateStakeInputsState(stakeInputs))
      dispatch(updatePlaceBetInfo())
    })
   
  }
}

/**
 * update odds value if user switch odds format on odds pages
 */
export const updateOddsForBetslip = () => {
  return (dispatch, getState) => {
    const {
      oddsSelection,
      selectedBetslipTab
    } = getState().BetslipSlice
    if (oddsSelection.length > 0) {
      if (selectedBetslipTab === BETSLIP_TABS.SINGLE) {
        dispatch(fetchSingleOddsSelectionInfo({isChangeOddsFormat: true}))

      } else if (selectedBetslipTab === BETSLIP_TABS.PARLAY) {
        dispatch(fetchParlayOddsSelectionInfo())
      }
      CommonUtil.scrollToTop()
    }
  }
}

export const reloadBalanceAndPendingBets = () => {
  window.fireEvent(EVENT.ACCOUNT_BALANCE_RELOAD)
  window.fireEvent(EVENT.FETCH_PENDING_BETS)
}

export const checkInvalidStake = () => {
  return (dispatch, getState) => {
    const { singleBets, stakeInputs } = getState().BetslipSlice
    let disable = false;
    if(!_.isEmpty(stakeInputs)){
      singleBets.forEach(bet => {
        if (stakeInputs[bet.oddsId]) {
          const stake = BetslipCommon.convertStakeToNumber(BetslipHelper.getStake(stakeInputs, bet.oddsId))
          if (!stake || stake === 0) {
            disable = true;
          }
        }
      })
    }
    dispatch(updateInvalidStake(disable))
  }
}

export const validateSingleBets = () => {
  return (dispatch, getState) => {
    const {oddsFormat} = getState().SportsSlice.options
    const {user} = getState().AccountsSlice
    const {singleBets, stakeInputs} = getState().BetslipSlice;
    const hrStakeInputs = getState().HRBetslipSlice.stakeInputs;
    const hrSingleBets = getState().HRBetslipSlice.singleBets;
    const limitBets = getState().HRBetslipSlice.limitBets;
    const preValidator = BetslipHelper.validateSingleBets(singleBets, stakeInputs, oddsFormat)
    const {
      validator,
      hrAdjustStakes
    } = BetslipHelper.validateHRSingleBets(hrSingleBets, hrStakeInputs, limitBets, preValidator, user.loginId, oddsFormat);
    const {
      totalRisk,
      totalWin
    } = BetslipHelper.getSingleWinRiskInfo({...stakeInputs, ...hrStakeInputs});
    if (validator.errorMessage) {
      dispatch(openAlert({
        message: validator.errorMessage,
      }))
      const adjustInputs = BetslipHelper.autoAdjustStake(stakeInputs, oddsFormat, validator)
      batch(() => {
        dispatch(resetStakeAndWinRiskOption())
        dispatch(updateStakeInputsState(adjustInputs))
        dispatch(updateHRStakeInputsState({...hrStakeInputs, ...hrAdjustStakes}));
        dispatch(updatePlaceBetInfo());
        dispatch(updatePlaceHRBetInfo());
      })
      
      return
    } 
    dispatch(opentConfirmAlert({
      title: 'Confirm bets',
      message: 'PARLAY_CONFIRM_BET',
      params:[totalRisk.toDollar(2, true), i18next.t(user.currency), totalWin.toDollar(2, true), i18next.t(user.currency)],
      fireEventKey: EVENT.ALERT_CONFIRM_PLACEBET
  }))
  }
}

export const updatePendingBetsToAcceptedBets = (pendingBets) => {
  return (dispatch, getState) => {
    if (getState().BetslipSlice.singleBets.length > 0) {
      const singleBets = JSON.parse(JSON.stringify(getState().BetslipSlice.singleBets))
      pendingBets.forEach((item, index) => {
        const betIndex = singleBets.findIndex(bet => {
          return bet.wagerId === item[WagerMyBetMap.wagerId] && bet.status === Constants.BET_STATUS.PENDING_ACCEPTANCE
        })
        if (betIndex > -1) {
          if (item[WagerMyBetMap.status] === Constants.WAGER_STATUS.OPEN) {
            Object.assign(singleBets[betIndex], {
              status: Constants.BET_STATUS.ACCEPTED,
              stake: BetslipCommon.convertStakeToNumber(item[WagerMyBetMap.stake]),
              win: BetslipCommon.convertStakeToNumber(item[WagerMyBetMap.toWin]),
              risk: BetslipCommon.convertStakeToNumber(item[WagerMyBetMap.toRisk])
            })
          } else if (item[WagerMyBetMap.status] === Constants.WAGER_STATUS.CANCELLED) {
            Object.assign(singleBets[betIndex], {
              status: Constants.BET_STATUS.PROCESSED_WITH_ERROR,
              errorCode: 'Your bet has been rejected.'
            })
          }
          if (singleBets[betIndex].status === Constants.BET_STATUS.ACCEPTED || singleBets[betIndex].status === Constants.BET_STATUS.PROCESSED_WITH_ERROR) {
            GA4Common.sendEventGA(GA_EVENT.BET_SLIP_LIVE_ACCEPTANCE, {
              tab: BETSLIP_TABS.SINGLE,
              data: singleBets[betIndex]
            });
          }
        }
      })
      dispatch(updateSingleBetsState(singleBets))
    }
  }
}

export const checkAttention = () => {
  return (dispatch, getState) => {
    const { selectedBetslipTab, attention } = getState().BetslipSlice
    const { selectedSportTab } = getState().SidebarSelectedDataSlice
    let isShowAttention = false
    if (selectedSportTab === SPORT_TABS.VIRTUAL_SPORTS) {
      const { oddSelections } = getState().VSBetslipSlice
      isShowAttention = VSBetslipHelper.isDisableVSBets(oddSelections)
    } else if (selectedBetslipTab === BETSLIP_TABS.PARLAY) {
      const { legs } = getState().ParlayBetslipSlice.parlayBets
      if (legs) {
        const isDisablePlaceBetBtn = BetslipHelper.isDisablePlaceBetBtn(legs) || legs.length < 2 || BetslipHelper.isInValidMixedRBParlayBet(legs);
        const isDefaultAttention = BetslipHelper.isDefaultAttention(attention, selectedBetslipTab);
        isShowAttention = isDisablePlaceBetBtn && legs.length > 1 || !isDefaultAttention;
      }
    } else if (selectedBetslipTab === BETSLIP_TABS.SINGLE) {
      const {singleBets} = getState().BetslipSlice
      isShowAttention = !BetslipHelper.isAllBetsSuccessfully(singleBets) && BetslipHelper.isDisablePlaceBetBtn(singleBets)
    }
    dispatch(updateShowAttentionState(isShowAttention))
  }
}
export const clearAcceptedSBBet = () => (dispatch, getState) => {
  const {singleBets, oddsSelection} = getState().BetslipSlice;
  const selection = oddsSelection.filter((bet) =>
      bet.status !== Constants.BET_STATUS.ACCEPTED && bet.status !== Constants.BET_STATUS.PENDING_ACCEPTANCE
  )
  const bets = singleBets.filter((bet) =>
      bet.status !== Constants.BET_STATUS.ACCEPTED && bet.status !== Constants.BET_STATUS.PENDING_ACCEPTANCE
  )
  batch(() => {
    dispatch(updateOddsSelectionState(selection))
    dispatch(updateSingleBetsState(bets))
  });
}

const invalidOddsFormatHandle = (dispatch) => {
  dispatch(openModalMessage({
    message: `errors:${Constants.BET_ERROR_CODE.INVALID_ODDS_FORMAT}`,
    title: 'Selection unavailable',
    fireEventKey: EVENT.UPDATE_MAX_BET_PREFERENCE_SETTING_BASE,
    fireCloseEventKey: EVENT.UPDATE_MAX_BET_PREFERENCE_SETTING_BASE,
  }));
}

export const betslipSelector = state => state.BetslipSlice
export const getSelectionOddsIds = state => _.map(state.BetslipSlice.oddsSelection, item=> item.oddsId);
export default BetslipSlice.reducer;



// WEBPACK FOOTER //
// ./src/app/slices/BetslipSlice.js